<template>
  <FlexCol gap-1>
    <Label :label="label" :required="required" :error="error" />

    <button
      type="button"
      class="flex items-center gap-2 px-2 text-sm text-left"
      :class="[{ 'h-6': dense, 'h-10': !dense }, { 'cursor-not-allowed opacity-60': disabled || disableAction }]"
      :disabled="disabled || disableAction"
      @click="update">
      <span
        class="flex size-6 items-center justify-center rounded border transition-colors"
        :class="computedStatus">
        <Transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="scale-0 opacity-0"
          enter-to-class="scale-100 opacity-100"
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="scale-100 opacity-100"
          leave-to-class="scale-0 opacity-0">
          <IconSolid v-if="inputValue" icon="fa-check" class="text-cockpit-canvas" />
        </Transition>
      </span>
      <span class="select-none">{{ status }}</span>
    </button>
    <Error :message="error" />
  </FlexCol>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
  disabled: { type: Boolean, default: false },
  error: Array,
  label: String,
  status: String,
  required: Boolean,
  modelValue: [Boolean, Number],
  dense: Boolean,
  checked: Boolean,
  disableAction: Boolean,
})

const emit = defineEmits(['update:modelValue'])
const inputValue = ref(Boolean(props.modelValue ?? props.checked ?? false))
const numericModel = computed(() => typeof props.modelValue === 'number')

const computedStatus = computed(() => [
  props.error ? 'border-cockpit-critical' : 'border-cockpit-line',
  inputValue.value ? 'bg-cockpit-green text-cockpit-canvas' : 'bg-cockpit-canvas',
])

const update = () => {
  const nextValue = !inputValue.value
  inputValue.value = nextValue
  emit('update:modelValue', numericModel.value ? Number(nextValue) : nextValue)
}

watch(
  () => props.modelValue,
  (newValue) => {
    inputValue.value = Boolean(newValue)
  },
  { immediate: true },
)
</script>
